import axios from 'axios';

import { API_URL } from '../config';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface Employee {
  id?: number;
  name: string;
  surname: string;
  email: string;
  phone?: string;
  address?: string;
  imageUrl?: string;
  /** 800px copy of the profile photo; missing on older backends */
  thumbnailUrl?: string;
  status?: string;
  user?: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
}

export interface EmployeeDocument {
  id: number;
  employee_id: number;
  name: string;
  path: string;
  document_url: string;
  created_at: string;
  updated_at: string;
}

export const getEmployees = async () => {
  const response = await api.get('/employees');
  return response.data;
};

export const employeeService = {
  getAll: getEmployees,

  getInactive: async () => {
    const response = await api.get('/employees/inactive');
    return response.data;
  },

  create: async (employee: Omit<Employee, 'id'>) => {
    const response = await api.post('/employees', employee);
    return response.data;
  },

  update: async (id: number, employee: Partial<Employee>) => {
    const response = await api.put(`/employees/${id}`, employee);
    return response.data;
  },

  delete: async (id: number) => {
    await api.delete(`/employees/${id}`);
  },

  activate: async (id: number) => {
    const response = await api.post(`/employees/${id}/activate`);
    return response.data;
  },

  getDocuments: async (employeeId: number): Promise<EmployeeDocument[]> => {
    const response = await api.get(`/employees/${employeeId}/documents`);
    return response.data;
  },

  uploadDocument: async (employeeId: number, file: File, name: string): Promise<EmployeeDocument> => {
    const formData = new FormData();
    formData.append('employee_id', employeeId.toString());
    formData.append('document', file);
    formData.append('name', name);
    
    const response = await api.post('/employees/upload-document', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteDocument: async (documentId: number): Promise<void> => {
    await api.delete(`/employees/documents/${documentId}`);
  },

  regeneratePassword: async (employeeId: number) => {
    const response = await api.post(`/employees/${employeeId}/regenerate-password`);
    return response.data;
  }
}; 